'use client'

import { Spinner } from '@/components/extension/spinner'
import { ProductFormatted } from '@/types/product'
import {
  ProductCardProvider,
  useProductCardContext,
} from './context/product-card-context'
import { ProductItemInfo } from './product-item-info'
import { ProductItemThumbnail } from './product-item-thumbnail'

type Props = {
  product: ProductFormatted
}

const ProductCardContent = () => {
  const { isPendingAddToCart } = useProductCardContext()

  return (
    <div className='relative w-full shrink-0 grow-0'>
      {isPendingAddToCart ? (
        <div
          className='absolute inset-0 z-10 flex items-center justify-center bg-neutral-100/50'
          role='status'
          aria-label='Adding to cart'
        >
          <Spinner size='large' />
        </div>
      ) : null}
      <figure className='space-y-3' role='group' aria-label='Product card'>
        <ProductItemThumbnail />
        <ProductItemInfo />
      </figure>
    </div>
  )
}

export const ProductCard = ({ product }: Props) => {
  return (
    <ProductCardProvider product={product}>
      <ProductCardContent />
    </ProductCardProvider>
  )
}
